import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import { ThemeProvider } from './lib/theme-provider';
import { ErrorBoundary } from './components/ErrorBoundary';
import { auth } from './lib/auth';
import './index.css';
// import 'ai-app-client'; // 临时注释以排查问题

// Initialize auth module before rendering app
auth.init()

const root = document.getElementById('root');
if (root) {
  ReactDOM.createRoot(root).render(
    <React.StrictMode>
      <ErrorBoundary>
        <ThemeProvider>
          <App />
        </ThemeProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
}
